import {AppProps} from "../../interfaces";
import * as React from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {mapDispatchToProps, mapStateToProps} from "../../../../../store/mappers";
//import {info} from "../../../../../services/route-service";



const checkPrincipal: any = <P extends AppProps> ( WrappedComponent: React.ComponentType<P> ) => {
    return (props: P & AppProps) => {

        // the user is unauthenticated but ui token is present - means token is expired, redirecting to uaa to reauthenticate
        if (props.userPrincipal.unauthenticatedUser && props.userPrincipal.uiTokenPresent) {
            let redirectUrl = 'https://'+props.portalProperties.uaaHost+'/auth-login?target='+window.location.href;
            window.location.href= redirectUrl
        }

        return <WrappedComponent {...props} />
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), checkPrincipal);